import React from 'react';

import styles from './MessageContainer.module.scss';

export default function MessageContainer({ message, role }) {
	const label = role === 'user' ? 'пользователь' : 'система';
	return (
		<div className={styles.container}>
			<div className={styles.labelContainer}>
				<span className={styles.label}>{label}</span>
			</div>
			<div className={styles.messageContainer}>
				<span className={styles.message}>{message}</span>
			</div>
		</div>
	);
}
